/**
 * Barrel wrapper
 * @param {Barrel} barrel - графический компонент БАРАБАН (или что-то подобное)
 * */

import { TYPE } from "./network/network_api";

export default function ( barrel, parent, $ticker, freegamesBarrel )
{
    
    barrel.container.visible = false;
    if (freegamesBarrel) {
        freegamesBarrel.container.visible = false;
    }
    
    const space = parent.child( "barrel" );
    
    const $reelStop = space.s( "reelStop" );
    const $reelStopping = space.s( "reelStopping" );
    const $stop = space.s( "stop" );
    const delegate = b => b.setDelegate( {
        barrelDidStop: () => $stop.next(),
        reelDidStop : reel => $reelStop.next( reel ),
        onReelStopping: (reel, offset) => $reelStopping.next( {reel, offset} )
    } );
    delegate( barrel );
    if ( freegamesBarrel ) delegate( freegamesBarrel );
    
    const $click = space.s( "click" );
    barrel.container.on( 'tap', () => $click.next() );
    barrel.container.on( 'click', () => $click.next() );
    if ( freegamesBarrel )
    {
        freegamesBarrel.container.on( 'tap', () => $click.next() );
        freegamesBarrel.container.on( 'click', () => $click.next() );
    }
    
    $ticker.subscribe( dt => {
        const t = Math.min( dt, 0.02 );
        barrel.update( t );
        if ( freegamesBarrel ) freegamesBarrel.update( t );
    } );
    
    const b = isFreegames => {
        if ( isFreegames && freegamesBarrel )
        {
            barrel.container.visible = false;
            freegamesBarrel.container.visible = true;
            return freegamesBarrel;
        }
        else
        {
            barrel.container.visible = true;
            if ( freegamesBarrel ) freegamesBarrel.container.visible = false;
            return barrel;
        }
    };
    
    space.s( "start" ).subscribe( ({
        isFreegames,
        previousSymbols,
        newSymbols
    }) => b( isFreegames ).startRotate(
        true,
        previousSymbols,
        newSymbols
    ) );
    
    space.s( "end" ).subscribe( stop =>
    {
        const math = stop.data.state.stage.math;
        const symbols = math.jumps ? math.jumps[ 0 ].symbols : math.symbols; // ArabianTales specific :(
        
        const target = b( stop.data.type == TYPE.FREESPIN );
        
        target.setStopElements( symbols );
        
        target.setInfiniteRotate( false );
        if ( stop.interrupted )
        {
            target.stopRotate();
        }
    } );
    
    //display specified symbols on barrel without rotating it (state restoration mostly):
    space.s( "static" ).subscribe( symbols => {
        barrel.container.visible = true;
        barrel.setCurrentElements( symbols );
    } );
    
    return {
        barrel,
        space,
    };
}




// WEBPACK FOOTER //
// ./src/library/barrel_view.es6